const SocialNetworks = {
  snapchat: {
    color: '#FFFB54',
    height: 1438,
    receipt: '/receipts/Snapchat.svg',
    type: 'color',
    textColor: 'dark',
  },
  facebook: {
    color: '#3B5998',
    height: 2109,
    receipt: '/receipts/Facebook.svg',
    type: 'color',
    textColor: 'light',
  },
  instagram: {
    color: 'linear-gradient(45deg, #F50000 24%, #B900B4 64%, #1400C8)',
    height: 2175,
    receipt: '/receipts/Instagram.svg',
    type: 'gradient',
    textColor: 'dark',
  },
  youtube: {
    color: '#FF0000',
    height: 1650,
    receipt: '/receipts/Youtube.svg',
    type: 'color',
    textColor: 'dark',
  },
  tumblr: {
    color: '#35465C',
    height: 1324,
    receipt: '/receipts/Tumblr.svg',
    type: 'color',
    textColor: 'light',
  },
  dribbble: {
    color: '#EA4C89',
    height: 747,
    receipt: '/receipts/Dribbble.svg',
    type: 'color',
    textColor: 'light',
  },
  pinterest: {
    color: '#BD081C',
    height: 1324,
    receipt: '/receipts/Pinterest.svg',
    type: 'color',
    textColor: 'light',
  },
  twitter: {
    color: '#1DA1F2',
    height: 1621,
    receipt: '/receipts/Twitter.svg',
    type: 'color',
    textColor: 'light',
  },
  medium: {
    color: '#02B875',
    height: 1378,
    receipt: '/receipts/Medium.svg',
    type: 'color',
    textColor: 'light',
  },
};

export default SocialNetworks;
